var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6036_76153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 11C7.5 9.89543 8.39543 9 9.5 9V6H10.5C11.0523 6 11.5 5.55229 11.5 5C11.5 4.44771 11.0523 4 10.5 4H9.5V1L14 1C15.1046 1 16 1.89543 16 3L16 13C16 14.1046 15.1046 15 14 15L9.5 15V13C8.39543 13 7.5 12.1046 7.5 11ZM14 14L10.5 14V12H9.5C8.94772 12 8.5 11.5523 8.5 11C8.5 10.4477 8.94772 10 9.5 10H10.5L10.5 7C11.6046 7 12.5 6.10457 12.5 5C12.5 3.89543 11.6046 3 10.5 3V2L14 2C14.5523 2 15 2.44772 15 3L15 13C15 13.5523 14.5523 14 14 14Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 5C8.5 6.10457 7.60457 7 6.5 7V10H5.5C4.94772 10 4.5 10.4477 4.5 11C4.5 11.5523 4.94772 12 5.5 12H6.5V15H2C0.89543 15 0 14.1046 0 13V3C0 1.89543 0.895431 1 2 1H6.5V3C7.60457 3 8.5 3.89543 8.5 5ZM2 2H5.5V4H6.5C7.05228 4 7.5 4.44772 7.5 5C7.5 5.55229 7.05228 6 6.5 6H5.5L5.5 9C4.39543 9 3.5 9.89543 3.5 11C3.5 12.1046 4.39543 13 5.5 13L5.5 14H2C1.44772 14 1 13.5523 1 13V3C1 2.44772 1.44772 2 2 2Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6036_76153)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleOutlined);
export default __webpack_public_path__ + "static/media/puzzle-outlined.22df2582792ed43ad74e82dc73a5cb7f.svg";
export { ForwardRef as ReactComponent };